var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getPercentOrNumberValue } from '../utils/math';
export function getDefaultFacetOption() {
    return {
        type: 'none',
        callback: function (width, height) {
            return [
                {
                    x: 0,
                    y: 0,
                    width: width,
                    height: height,
                },
            ];
        },
        customFacet: [
            {
                x: 0,
                y: 0,
                width: '100%',
                height: '100%',
            },
        ],
    };
}
export function getFacetAreas(x, y, width, height, facetOption) {
    if (facetOption.type === 'none') {
        return [
            {
                x: x,
                y: y,
                width: width,
                height: height,
            },
        ];
    }
    if (facetOption.type === 'custom') {
        return facetOption.customFacet.map(function (facetItem) {
            return {
                x: x + getPercentOrNumberValue(facetItem.x, width),
                y: y + getPercentOrNumberValue(facetItem.y, height),
                width: getPercentOrNumberValue(facetItem.width, width),
                height: getPercentOrNumberValue(facetItem.height, height),
            };
        });
    }
    if (facetOption.type === 'callback') {
        return facetOption.callback(width, height).map(function (area) {
            return __assign(__assign({}, area), { x: area.x + x, y: area.y + y });
        });
    }
}
